<template>
  <div>
<!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>科室管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="department_name" align="center" label="名称" width="300">
      </el-table-column>
      <el-table-column prop="department_id" align="center" label="部门ID" width="100">
      </el-table-column>
      <el-table-column prop="can_reservation" align="center" label="挂号" width="100">
        <template slot-scope="scope">
            <div v-show="scope.row.can_reservation == 1">是</div><div v-show="scope.row.can_reservation == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="deptinfo" label="科室介绍">
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editDept(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑科室简介 -->
    <el-dialog title="科室简介" :visible.sync="deptinfoVisible">
      <el-form :model="form">
        <el-input type="textarea" v-model="form.deptinfo"></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { departmentlist,deptInfo } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        deptinfoVisible: false,
        formInline: {
          page: 1,
          limit: 10
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listData: [], //表格数据
        form: {
          deptinfo: ''
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created(){
      this.getdata(this.formInline)
    },
    methods:{
      getdata(parameter) {
        this.loading = true
        departmentlist(parameter).then(res => {
            this.loading = false
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      editDept(row) {
        console.log(row);
        this.form = row;
        this.deptinfoVisible = true;
      },
      submitform() {
        let data = {deptid:this.form.department_id,deptname:this.form.department_name,deptinfo:this.form.deptinfo}
        this.loading = true;
        deptInfo(data).then(res => {
          this.loading = false;
          this.deptinfoVisible = false;
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            });
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false;
          this.deptinfoVisible = false;
          this.$message.error('修改失败，请稍后再试！')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/base/Department.vue